import React from 'react';

export default function ShippingPolicy() {
  return (
    <div className="py-20 bg-white min-h-[60vh]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-gray">
        <h1 className="text-3xl font-serif mb-6 text-gray-900">Shipping & Service Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: [Current Date]</p>
        
        <p>Thank you for choosing Tatvam for your premium suiting and custom tailoring needs.</p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">Tailoring Timelines</h2>
        <p>Custom tailoring is a meticulous process. Standard completion time for bespoke garments is between 2 to 3 weeks from the date of final measurement and fabric selection. Expedited services may be available upon request at an additional charge.</p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">Fittings</h2>
        <p>We generally require 1-2 trial fittings to ensure the perfect drape and fit. Clients are requested to visit our Jaipur store for these fittings.</p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">Shipping of Finished Garments</h2>
        <p>While we recommend in-store pickup to verify the final fit, we do offer domestic shipping within India for finished garments. Shipping costs will be calculated at the time of dispatch. We currently do not process international shipments directly through the website.</p>
      </div>
    </div>
  );
}